import moment from "moment";
import modelBaseV2 from "../model-base-v2.model";

const SEAOPOSMAuthorizationModel = {
  getSEAOUserMovementWarehouseMap: (body) => {
    return modelBaseV2.post('/api/seao/posmAuthorization/getListUserWmMap', { body })
  },

  updateSEAOUserMovementWarehouseMap: (body) => {
    return modelBaseV2.post('/api/seao/posmAuthorization/saveUserWmMap', { body })
  },

  checkSEAOUserMovementWarehouseMapAuthorization: function (params) {
    return modelBaseV2.get('/api/seao/posmAuthorization/checkAuthorizeWM', { params })
  },
  downloadSEAOUserMovementWarehouseMapExcel: (body) => {
    let filename = `User_Movement_Warehouse_Map_${moment().format('YYYYMMDDHHmmss')}_Report.xlsx`
    let params = [
      { code: "152", value: body.movementType || '' },
      { code: "32", value: body.users },
      { code: "3", value: '1' },
      { code: "4", value: '-1' },
    ]

    const exportConfig = {
      excelSheetNames: [
        "User Warehouse Map"
      ],
      storedProcedureCode: "74",
      params
    }
    return modelBaseV2.postDownload('/api/survey/export/tr/file', { body: exportConfig }, filename)
  }
}
export const {
  getSEAOUserMovementWarehouseMap,
  updateSEAOUserMovementWarehouseMap,
  checkSEAOUserMovementWarehouseMapAuthorization,
  downloadSEAOUserMovementWarehouseMapExcel
} = SEAOPOSMAuthorizationModel
